/**
 * Title painted on the editor's structural-anchor tab (架构方案 §5.7). The anchor
 * only becomes a user-visible tab once instance tabs lift the strip, and it then
 * stands for «the main view» — so its label is the currently active rail
 * module's translated name, which `workbench.tsx` computes and `layout.tsx`
 * provides here. Same reason as {@link SurfaceHostContext}: dockview forwards
 * only serializable `params`, so live workbench state reaches a tab component
 * through Context.
 */
import { createContext } from 'react';

export const EditorSingletonTitleContext = createContext('');
